import { MRT_ColumnDef, MRT_RowData } from 'material-react-table';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckPermissions, useTableFilter } from '@/shared';
import { useDeleteCostos, useUpdateCostos, usefetchCostos } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SampleTable,
  SingleButton,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { useUiConfirmModalStore } from '@/store/ui';
import { Costos } from '@/shared/interfaces/erp/activos/costo-activo.interface';
import PaymentIcon from '@mui/icons-material/Payment';
import { TreeNode } from '@/shared/interfaces';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { Grid } from '@mui/material';
import { PermissionsEnum } from '@/auth/interfaces';


const returnUrlCosto = '/inventario/costos';

export interface CostosPageInterface { }

const CostosPage: React.FC<CostosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_costo)


  const [details, setDetails] = useState<TreeNode[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  const deleteCostosMutation = useDeleteCostos();

  ///* table
  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;
  ///* fetch data
  const {
    data: CostosPagingRes,
    isLoading,
    isRefetching,
  } = usefetchCostos({
    page: pageIndex + 1,
    page_size: 10,
  });
  ///* mutations
  /*  const updateIvaMutation = useUpdateCostos(navigate, returnUrl); */
  ///* handlers
  const onEdit = (original: Costos) => {
    navigate(`${returnUrlCosto}/editar/${original.id_costo}`);
  };
  const onDelete = (original: Costos) => {
    setConfirmDialog({
      isOpen: true,
      subtitle: '¿Está seguro que desea eliminar el Costo seleccionado?',
      title: 'Confirmar',
      onConfirm: () => {
        deleteCostosMutation.mutate(original.id_costo!);
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },
    });
  };
  ///* columns
  const updateCostoMutation = useUpdateCostos({
    navigate,
    returnUrl: returnUrlCosto,
  }
  )
  const onDetails = (e: MRT_RowData) => {
    setDetails(JSON.parse(e.cuentas_contables));
    setIsModalOpen(true);
  }
  ///* columns
  const columnsPlan = useMemo<MRT_ColumnDef<TreeNode>[]>(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Numero Cuenta',
        size: 150
      },

      {
        accessorKey: 'name',
        header: 'Nombre de la cuenta',
        size: 500,
      },
    ],
    [],
  );
  const columns = useMemo<MRT_ColumnDef<Costos>[]>(
    () => [

      {
        accessorKey: 'codigo',
        header: 'codigo',
        size: 200,
      },
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
        size: 200,
      },
      {
        accessorKey: 'nombre',
        header: 'nombre',
        size: 200,
      },
      {
        accessorKey: 'descripcion',
        header: 'descripcion',
        size: 200,
      },
      {
        accessorKey: 'costos',
        header: 'costos',
        size: 200,
      },
      {
        accessorKey: 'cif',
        header: 'cif',
        size: 200,
      },
      {
        accessorKey: 'mano_obra_directa',
        header: 'mano de obra directa',
        size: 200,
      },
      {
        accessorKey: 'mano_obra_indirecta',
        header: 'mano de obra indirecta',
        size: 200,
      },
      {
        accessorKey: 'cuentas_contables',
        header: 'Cuentas contables',
        size: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="ver"
                variant="text"
                color="info"
                onClick={() => {
                  onDetails(row.original);
                }}
                startIcon={<PaymentIcon />}
              />
            </>
          )
        },
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Costo' : 'Costo'}
            setEstadoSwitch={Costo => {
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateCostoMutation.mutate({
                    id: row.original.id_costo!,
                    data: {
                      ...row.original,
                      estado: Costo as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );
  return (
    <SingleTableBoxScene title="Costos" urlRedirect={`${returnUrlCosto}/crear`}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Costos" />

      <GeneralTable<Costos>
        columns={columns}
        data={CostosPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={CostosPagingRes?.data?.count}
        // // actions
        actionsColumnSize={120}
        // crud
        onEdit={onEdit}
        canDelete
        onDelete={onDelete}
      />
      <ScrollableDialogProps
        open={isModalOpen}
        title="Plan cuentas"
        onCloseIcon={()=>setIsModalOpen(false)}
        //cancelTextBtn="Cerrar"
        //onClose={() => setIsModalOpen(false)}
        minWidth="40%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {details.length > 0 && (
                  <SampleTable<TreeNode>
                    columns={columnsPlan}
                    data={details}
                    enablePagination={true}
                    density='compact'
                  />
                )}
              </Grid>
            </Grid>
          </>
        }
      />
    </SingleTableBoxScene>
  );
};
export default CostosPage;